export default "__VITE_ASSET__AaCX$gc2__"